<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warning/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('gongyicanshu')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--							:ids.sync="yt.conditions.equipmentId">-->
            <!--						</yi_cross_select>-->

            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('weichuli')" :value="0"></el-option>
              <el-option :label="$t('yichuli')" :value="1"></el-option>
              <el-option :label="$t('yiquxiao')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('yujingshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.warningTimeStart" :end.sync="yt.conditions.warningTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime,warningTime desc' })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 推送人员 -->
      <template #tuisongrenyuan="scope">
        <span v-for="(user, i) in scope.row.pushUser"> <span v-if="i != 0">,</span>{{ user.nickname }} </span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-button type="text" @click="yt.showEditDialog('querenjiejue', scope.row, 'w1')">{{ $t('querenjiejue') }}</el-button>
            <el-popconfirm :title="$t('shifouquerenquxiaoyvjin?')" :confirm-button-text="$t('querenquxiao')" @confirm="cancel(scope.row)">
              <el-button type="text" slot="reference">{{ $t('quxiaoyujing') }}</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'querenjiejue'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jiejuecuoshi')" required>
            <el-input v-model="yt.editObj.solution" maxlength="200" show-word-limit type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/warning/confirm', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('baoyangfenzu')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baoyangleixing')" required>
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('shoucibaoyang')" :value="1"></el-option>
              <el-option :label="$t('dingqibaoyang')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zhouqileixing')" required>
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('hemocishu')" :value="1"></el-option>
              <el-option :label="$t('antian')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zhouqichangdu')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baoyanghaoshi(xiaoshi)')" required>
            <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.code"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/setting/shiftType/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_process_management_warning_list',
  components: {},
  data() {
    return {
      columns: [
        {
          label: 'gongyicanshu',
          prop: 'name',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'yujingneirong',
          prop: 'content'
        },
        {
          label: 'yujingshijian',
          prop: 'warningTime',
          type: 'time',
          width: 130
        },
        {
          label: 'queren/quxiaoshijian',
          prop: 'confirmTime',
          type: 'time',
          width: 130
        },
        {
          label: 'jiejuecuoshi',
          prop: 'solution'
        },
        {
          label: 'gongyizhinanbianma',
          prop: 'manageCraftGuideCode'
        },
        {
          label: 'tuisongrenyuan',
          type: 'slot'
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'tag',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('weichuli')
            },
            1: {
              color: '#67C23A',
              text: this.$t('yichuli')
            },
            2: {
              color: '#909399',
              text: this.$t('yiquxiao')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime,warningTime desc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeAdd(params, url) {
      params.status = 1;
      return params;
    },
    cancel(editObj) {
      this.http
        .post('/web/warning/cancel', {
          id: editObj.id,
          status: 2
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    }
  }
};
</script>
